"use client"

import Link from "next/link"
import styles from "./MainButton.module.css"

const MainButton = ({
    href = "/create",
    children = "Get Started",
    className = "",
    wrapperClassName = "",
    id = "",
    ...props
}) => {
    return (
        <div className={`${styles.techButtonWrapper} ${wrapperClassName}`}>
            <Link
                href={href}
                className={`${styles.techButton} relative btn btn-xl rounded-full w-auto px-8 whitespace-nowrap text-white ${className}`}
                id={id}
                {...props}
            >
                <span className={styles.techButtonContent}>{children}</span>
                <span className={styles.techButtonBorder}></span>
            </Link>
        </div>
    )
}

export default MainButton

